import { render, staticRenderFns } from "./ThemeGroupbuyingCreate.vue?vue&type=template&id=1ca923f0&"
import script from "./ThemeGroupbuyingCreate.vue?vue&type=script&lang=js&"
export * from "./ThemeGroupbuyingCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports